import React from 'react';
import { Space } from '@masterteam/mt-design-react';

import KPIHistory from '../../KPIHistory/History';

import './style.scss';

function History({ data }) {
  return (
    <Space className="approve-reject-modal__history">
      <KPIHistory measureItem={data} />
    </Space>
  );
}

export default History;
